export const container = {
  MuiContainer: {
    defaultProps: {
      maxWidth: false,
    },
  },
};
